var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader"),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _vm.plots.isLoading == false
            ? _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n      Number of plots: " +
                      _vm._s(_vm.plots.totalCount) +
                      "\n      "
                  ),
                  _c(
                    "v-list",
                    { attrs: { "three-line": "" } },
                    [
                      _vm._l(_vm.plots.data, function (plot, i) {
                        return [
                          i != 0
                            ? _c("v-divider", { key: `divider-${plot.Id}` })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("PlotHeader", {
                            key: plot.Id,
                            attrs: { plot: plot },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }